import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: {
      isLogin: false,
      userName: '',
      loginName: '',
      identificationCard: '',
      phone: ''
    }
  },
  mutations: {
    // 设置登录状态
    SET_LOGIN_STATUS (state, { isLogin, userName, loginName, identificationCard, phone }) {
      state.user.isLogin = isLogin
      state.user.userName = userName || loginName || ''
      state.user.loginName = loginName || ''
      state.user.identificationCard = identificationCard || ''
      state.user.phone = phone || ''
    },
    // 清除登录状态
    CLEAR_LOGIN_STATUS (state) {
      state.user.isLogin = false
      state.user.userName = ''
      state.user.loginName = ''
      state.user.identificationCard = ''
      state.user.phone = ''
    }
  },
  actions: {
    // 初始化登录状态（从 localStorage 读取）
    initLoginStatus ({ commit }) {
      const applicantInfo = localStorage.getItem('applicantInfo')
      const isLogin = localStorage.getItem('isLogin')
      const loginName = localStorage.getItem('loginName')
      const identificationCard = localStorage.getItem('loginIdentificationCard')
      
      let userName = ''
      let loginStatus = false
      let phone = ''
      
      // 优先检查 applicantInfo
      if (applicantInfo) {
        try {
          const info = JSON.parse(applicantInfo)
          if (info && info.loginName) {
            userName = info.loginName
            loginStatus = true
            phone = info.phone || ''
          }
        } catch (e) {
          // 解析失败，继续检查其他方式
        }
      }
      
      // 如果没有 applicantInfo，检查 isLogin 和 loginName
      if (!loginStatus && isLogin === 'true' && loginName) {
        userName = loginName
        loginStatus = true
      }
      
      commit('SET_LOGIN_STATUS', {
        isLogin: loginStatus,
        userName,
        loginName: loginName || userName,
        identificationCard,
        phone
      })
    },
    // 设置登录状态
    setLoginStatus ({ commit }, { userName, loginName, identificationCard, phone }) {
      commit('SET_LOGIN_STATUS', {
        isLogin: true,
        userName: userName || loginName,
        loginName: loginName || userName,
        identificationCard,
        phone: phone || ''
      })
    },
    // 清除登录状态
    clearLoginStatus ({ commit }) {
      commit('CLEAR_LOGIN_STATUS')
    }
  },
  modules: {
  }
})
